let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ggkqU")).then(() => parcelRequire('2hyOi'));